module.exports = __webpack_public_path__ + "img/Mask group@2x.c0d00328.png";